import React, { useCallback } from 'react';

import MultipleChoiceQuestionContainer from '@ts-core/modules/multipleChoiceExercises/components/MultipleChoiceQuestionContainer';

import { MultipleChoiceQuestion } from '../../types';

import MultipleChoiceQuestionOptionInput from '../MultipleChoiceQuestionOptionInput';

interface MultipleChoiceQuestionInputProps {
  question?: MultipleChoiceQuestion;
  loading?: boolean;
  onSelectOption: (option: any, questionId: string) => void;
  getSelectedOption: (question?: MultipleChoiceQuestion) => string | undefined;
}

const MultipleChoiceQuestionInput = (props: MultipleChoiceQuestionInputProps) => {
  const { question, loading, onSelectOption, getSelectedOption } = props;

  const handleChangeValue = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (question) {
        const value = event.target.value;
        onSelectOption(value, question._id);
      }
    },
    [question, onSelectOption]
  );

  return (
    <MultipleChoiceQuestionContainer
      question={question}
      loading={loading}
      selectedOption={getSelectedOption(question)}
      onChangeOption={handleChangeValue}
      noColors
      hideScores
      renderOption={(index, option) => <MultipleChoiceQuestionOptionInput key={option?._id || index} option={option} loading={loading} />}
      renderNoAnswerOption={() => <MultipleChoiceQuestionOptionInput />}
    />
  );
};

export default MultipleChoiceQuestionInput;
